import { useCallback } from 'react';
import { tracker } from '@kueski-dev/web-observability';
import { trackEvent } from '@kueski-analytics/events/home';
import { BRAZE_KUESKI } from 'Src/consts/observabilityTargets';
import { TrackerMediator } from '@kueski-analytics/utils/TrackerMediator';
import { EVENT_FEATURE_FLAGS } from '@kueski-analytics/utils/EventFeatureFlags';
import useInteractionChannel from './useInterationChannel';

export default function useTrackStartSession() {
  const interactionChannel = useInteractionChannel();

  const trackStartSession = useCallback(() => {
    const oldEvent = () => (
      trackEvent('start_session', { interaction_channel: interactionChannel }, 'braze')
    );
    const newEvent = () => (
      tracker.track('action', {
        attributes: { action_name: 'session_start' },
        target: BRAZE_KUESKI,
      })
    );

    const mediator = new TrackerMediator(EVENT_FEATURE_FLAGS.home);
    mediator
      .addOldTracker(oldEvent)
      .addNewTracker(newEvent)
      .track();
  }, [interactionChannel]);

  return trackStartSession;
}
